<template>
	<div class="mainWrapper pi">
		<h1>Purchase Invoice</h1>

		<div class="links">
			<b-button type="is-info"
				><router-link to="/export/pi">
					Export PI
				</router-link></b-button
			>
		</div>

		<div class="general-search">
			<div>
				<b-field>
					<b-input v-model="searchPICode" placeholder="PI Code" @keyup.native.enter="searchPI"></b-input>
				</b-field>
			</div>

			<div>
				<b-button type="is-info" @click="searchPI()" icon-left="magnify">Search</b-button>
			</div>
		</div>

		<div class="list" v-if="list">
			<div class="piList header">
				<div>PI CODE</div>
				<div>BRAND</div>
				<div>APPROVED BY</div>
				<div>CREATED AT</div>
				<div></div>
			</div>

			<div v-for="(item, index) of list" v-bind:key="index" class="piList">
				<div>{{ item.code }}</div>
				<div>{{ item.brand }}</div>
				<div>{{ item.author.name }}</div>
				<div>{{ convertTime(item.createdAt) }}</div>
				<div @click="viewPIDetail(item._id, item.brand)" class="hyperlink">
					<ios-arrow-forward-icon w="32px" h="32px" />
				</div>
			</div>

			<paginate
				v-model="page"
				:page-count="pageCount"
				:click-handler="pagerClick"
				:prev-text="'prev'"
				:next-text="'next'"
				:container-class="'pagination'"
			>
			</paginate>
		</div>
	</div>
</template>

<script>
export default {
	name: 'PurchaseOrder',
	data: function() {
		return {
			limit: this.$config.pageItemsLimit, // For pager
			list: null, // Will contain all the list
			pageCount: 1, // For pager
			page: 1, // For pager
			searchPICode: null
		}
	},
	watch: {},
	mounted: async function() {
		// Get all the PO
		var data = {
			limit: this.limit,
			populate: ['author', 'purchase_order']
		}

		const apiGetPI = await this.$api.getPI({ data })

		if (apiGetPI !== undefined) {
			await Promise.all(
				apiGetPI.data.list.map(async item => {
					var data = {
						id: item.purchase_order.brand
					}

					const apiGetBrand = await this.$api.getBrand({ data })

					if (apiGetBrand !== undefined) {
						item.brand = apiGetBrand.data.list[0].name
					}
				})
			)
		}

		this.pageCount = Math.ceil(apiGetPI.data.total / this.limit)

		this.list = apiGetPI.data.list
	},

	methods: {
		// When user entered search
		searchPI: async function() {
			// Calculate how many items to skip

			var data = {
				limit: this.limit,
				populate: ['author', 'purchase_order']
			}

			if (this.searchPICode && this.searchPICode.length > 0) {
				data.code = this.searchPICode
			}

			const apiGetPI = await this.$api.getPI({ data })

			if (apiGetPI !== undefined) {
				await Promise.all(
					apiGetPI.data.list.map(async item => {
						var data = {
							id: item.purchase_order.brand
						}

						const apiGetBrand = await this.$api.getBrand({ data })

						if (apiGetBrand !== undefined) {
							item.brand = apiGetBrand.data.list[0].name
						}
					})
				)
			}

			this.pageCount = apiGetPI.data.total / this.limit
			this.list = apiGetPI.data.list
		},

		// When user click on page number
		pagerClick: async function(pageNumber) {
			// Calculate how many items to skip
			var skip

			if (pageNumber == 1) {
				skip = 0
			} else {
				skip = (pageNumber - 1) * this.limit
			}

			var data = {
				limit: this.limit,
				skip,
				populate: ['author', 'purchase_order']
			}

			if (this.searchPICode && this.searchPICode.length > 0) {
				data.code = this.searchPICode
			}

			const apiGetPI = await this.$api.getPI({ data })

			if (apiGetPI !== undefined) {
				await Promise.all(
					apiGetPI.data.list.map(async item => {
						var data = {
							id: item.purchase_order.brand
						}

						const apiGetBrand = await this.$api.getBrand({ data })

						if (apiGetBrand !== undefined) {
							item.brand = apiGetBrand.data.list[0].name
						}
					})
				)
			}
			this.pageCount = Math.ceil(apiGetPI.data.total / this.limit)

			this.list = apiGetPI.data.list
		},

		// Push to detail page
		viewPIDetail: function(id, brand) {
			this.$router.push('/pi/detail/' + id + '/' + brand)
		},

		// Convert time
		convertTime: function(time) {
			return this.$moment(time).format('DD/MM/YY hh:mm a')
		}
	}
}
</script>

<style scoped>
@import '../styles/PI.css';
</style>
